// extracted by mini-css-extract-plugin
export default {"content_dt":"Guara_content_dt__Gux8P","content_dtfilmes":"Guara_content_dtfilmes__mi-Lm","wrapper":"Guara_wrapper__yO7ml"};